import { __assign } from "tslib";
import { CoherenceTheme } from '@cseo/styles';
import { CommandBarButton, css, FontSizes, mergeStyleSets, TooltipHost } from '@fluentui/react';
import React from 'react';
export function onRenderCommandBarButton(item) {
    var Styles = HeaderActionsStyles;
    var buttonClassName = item.renderedInOverflow ? Styles.rightItemButtonOverflow : Styles.rightItemButton;
    var buttonIconClassName = item.renderedInOverflow ? Styles.rightItemButtonOverflowIcon : Styles.rightItemButtonIcon;
    var requestedClassName = item.iconProps ? item.iconProps.className : undefined;
    var iconPropsClassName = requestedClassName ? css(requestedClassName, buttonIconClassName) : buttonIconClassName;
    var iconOnly = !item.renderedInOverflow;
    var itemText = item.text || item.name;
    var commandButtonProps = __assign(__assign({ allowDisabledFocus: true, role: 'menuitem' }, item), { text: !iconOnly ? itemText : undefined, checked: item.checked, menuProps: item.subMenuProps, iconProps: __assign(__assign({}, item.iconProps), { className: iconPropsClassName }), iconOnly: iconOnly, onClick: _onButtonClick(item), className: css('ms-CommandBarItem-link', buttonClassName, item.className), styles: __assign({ root: { height: '48px' }, label: { whiteSpace: 'nowrap', marginLeft: '10px' } }, item.buttonStyles), title: '' });
    if (itemText !== undefined) {
        return (React.createElement(TooltipHost, __assign({ content: itemText }, item.tooltipHostProps), _commandButton(item, commandButtonProps)));
    }
    return _commandButton(item, commandButtonProps);
}
function _commandButton(item, props) {
    if (item.commandBarButtonAs) {
        var Type = item.commandBarButtonAs;
        return React.createElement(Type, __assign({}, props));
    }
    return React.createElement(CommandBarButton, __assign({}, props));
}
function _onButtonClick(item) {
    return function (ev) {
        if (item.onClick) {
            item.onClick(ev, item);
        }
    };
}
var buttonWidth = 48;
export var HeaderActionsStyles = mergeStyleSets({
    rightItemButton: {
        width: buttonWidth + 'px',
        height: buttonWidth + 'px',
        backgroundColor: 'transparent',
        selectors: {
            ':hover': {
                backgroundColor: CoherenceTheme.palette.themeDarkAlt,
                selectors: {
                    '.notification-badge': {
                        color: CoherenceTheme.palette.themeDarkAlt,
                        backgroundColor: CoherenceTheme.palette.white
                    }
                }
            },
            ':active': {
                backgroundColor: CoherenceTheme.palette.themeDarker,
                selectors: {
                    '.notification-badge': {
                        color: CoherenceTheme.palette.themeDarker,
                        backgroundColor: CoherenceTheme.palette.white
                    }
                }
            },
            '&.is-checked': {
                backgroundColor: CoherenceTheme.palette.themeDarker,
                selectors: {
                    '.notification-badge': {
                        color: CoherenceTheme.palette.themeDarker,
                        backgroundColor: CoherenceTheme.palette.white
                    }
                }
            }
        }
    },
    rightItemButtonOverflow: {
        width: '100%',
        height: buttonWidth + 'px',
        backgroundColor: CoherenceTheme.palette.white,
        color: CoherenceTheme.palette.neutralPrimary,
        textAlign: 'left'
    },
    rightItemButtonIcon: {
        color: CoherenceTheme.palette.white + ' !important',
        backgroundColor: 'transparent !important',
        fontSize: FontSizes.size16
    },
    rightItemButtonOverflowIcon: {
        color: CoherenceTheme.palette.neutralPrimary + ' !important',
        fontSize: FontSizes.size14,
        margin: '0px',
        paddingLeft: '14px'
    }
});
//# sourceMappingURL=CoherenceHeaderHelpers.js.map